(function($) {
    function toggleAccordion(e) {
        e.preventDefault();
        var elem = $(this);
        var header = elem.closest(".ai-header");
        var item = header.closest(".accordion-item");
        var content = item.find(".ai-content").first();
        if(content.is(":visible")) {
            content.slideUp();
            header.removeClass("active");
        } else {
            content.slideDown();
            header.addClass("active");
        }
    }
    $(document).ready(function() {
        $(".ai-content").hide();
        $(".ai-header").click(toggleAccordion);
    });
})(jQuery);